import React, { useState } from "react";
import "./DateInput.css";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { IconButton, Tooltip } from "@mui/material";
import { ReactComponent as InfoIcon } from "../../../assets/images/info.svg";

const CustomInput = ({
  value,
  onClick,
  placeholder,
  readOnly,
  elemHeight,
  disabled,
}) => (
  <div
    className={`custom-input ${disabled ? "disabled-input" : ""}`}
    style={{ height: `${elemHeight ? elemHeight : "48"}px` }}
  >
    <div
      className="input-icon-wrapper"
      onClick={!disabled ? onClick : undefined}
    >
      <input
        type="text"
        readOnly={readOnly || disabled}
        value={value}
        placeholder={placeholder}
        className="input-with-icon"
        style={{ textAlign: value ? "center" : "left" }}
      />
    </div>
  </div>
);

const DateInput = ({
  heading,
  value,
  onChange,
  readOnly,
  minDate,
  maxDate,
  height,
  error,
  disabled,
}) => {
  const [calendarOpen, setCalendarOpen] = useState(false);
  return (
    <div className="inputDateContainer" style={{ position: "relative" }}>
      {heading && (
        <div className="inputextElem">
          {heading}
          {(heading === "Terms Expiry Date" ||
            heading === "Listing Expiry Date") &&
            !calendarOpen && (
              <div style={{ position: "relative" }}>
                <Tooltip
                  title="Expiry Date & Time should be at least 3 hours from first slot"
                  style={{
                    position: "absolute",
                    top: "-22px",
                    left: "120px",
                  }}
                >
                  <IconButton>
                    <InfoIcon style={{ width: "14px", height: "16px" }} />
                  </IconButton>
                </Tooltip>
              </div>
            )}
        </div>
      )}
      <div className="date-picker-container">
        <DatePicker
          selected={value}
          onChange={(date) => onChange(date)}
          onCalendarOpen={() => setCalendarOpen(true)}
          onCalendarClose={() => setCalendarOpen(false)}
          placeholderText="DD-MM-YYYY"
          customInput={
            <CustomInput
              readOnly={readOnly}
              elemHeight={height}
              placeholder="DD-MM-YYYY"
            />
          }
          dateFormat="dd-MM-yyyy"
          showYearDropdown
          showMonthDropdown
          scrollableMonthYearDropdown
          minDate={minDate ? new Date(minDate) : undefined}
          maxDate={maxDate ? new Date(maxDate) : undefined}
          popperPlacement="top-start"
          popperProps={{
            strategy: "fixed",
            modifiers: [
              {
                name: "zIndex",
                enabled: true,
                phase: "write",
                fn: ({ state }) => {
                  if (state && state.styles && state.styles.popper) {
                    state.styles.popper.zIndex = 9999;
                  }
                  return state;
                },
              },
            ],
          }}
          disabled={disabled}
        />
      </div>
      {error && <div className="dateErrorHeading">{error}</div>}
    </div>
  );
};

export default DateInput;
